import { otsBaseApi } from "../../ots-api";
import {
  PipelineFlowTransportReport,
  PipelineFlowTransportReportSearchCriteria
} from "../../../model/pipeline/pipeline-flow-transport-report";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['PipelineFlowTransportReports']})

const pipelineFlowTransportReportApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchPipelineFlowTransportReports: builder.query<
      PipelineFlowTransportReport[],
      PipelineFlowTransportReportSearchCriteria
    >({
      query: (criteria) => ({
        url: '/pipeline-flow-transport/reports/all',
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(
              ({ id }) =>
                ({ type: 'PipelineFlowTransportReports', id } as const)
            ),
            { type: 'PipelineFlowTransportReports', id: 'LIST' },
          ];
        } else {
          return [{ type: 'PipelineFlowTransportReports', id: 'LIST' }];
        }
      },
    }),
    getPipelineFlowTransportReport: builder.query<
      PipelineFlowTransportReport,
      string
    >({
      query: (id) => ({
        url: `/pipeline-flow-transport/reports/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [
        { type: 'PipelineFlowTransportReports', id },
      ],
    }),
    deletePipelineFlowTransportReport: builder.mutation<void, string>({
      query: (reportId) => ({
        url: `/pipeline-flow-transport/reports/${reportId}`,
        method: 'DELETE',
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: (result, error, reportId) => [
        { type: 'PipelineFlowTransportReports', reportId },
      ],
    }),
  }),
})

export const {
  useSearchPipelineFlowTransportReportsQuery,
  useLazySearchPipelineFlowTransportReportsQuery,
  useGetPipelineFlowTransportReportQuery,
  useDeletePipelineFlowTransportReportMutation,
} = pipelineFlowTransportReportApi;
